import { createAction } from '@ngrx/store';

export const activeCallsChanged = createAction('[Currently Viewing Active Calls Hub] Active Calls Changed.');
